var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Catalog Manager")]),_vm._l((_vm.apps),function(name,id){return _c('p',{key:id},[_c('router-link',{attrs:{"to":{name: 'CatalogManager', params:{id: id}}}},[_vm._v(_vm._s(name))])],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }